import login from './login';

export default {
  language: 'it-IT',
  country: 'it',
  name: 'Italiano',
  embeddedLocale: login,
};
